import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Label,
  makeStyles,
  tokens,
  useToastController,
  useId,
  Toaster,
} from "@fluentui/react-components";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import { POLICY_CASE_TYPE_MAP } from "./PolicyHomePage";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import CaseDetailDrawer from "../CaseDetailDrawer";
import {
  getPolicyDetailById,
  getPolicyPaymentDetailById,
  getPolicyPaymentsListItems,
} from "../../../../redux/Case/policySlice";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function PolicyPayments({ tab }: { tab: string }) {
  const navigate = useNavigate();
  const styles = useStyles();
  const { showToast, toasterId } = useToastMessage();
  const { clientId, case_type, action, caseId, subItemId } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const [currentRecord, setCurrentRecord] = useState(1);

  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const policies = useSelector((state: RootState) => state.policies);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);

  const caseType = case_type ? POLICY_CASE_TYPE_MAP[case_type] : "";
  const [isOpen, setIsOpen] = useState(false);
  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId) {
      dispatch(getPolicyDetailById({ id: caseId, customerId: clientId }));
      dispatch(
        getPolicyPaymentsListItems({ id: caseId, customerId: clientId })
      );
    }
  }, [caseId, clientId, dispatch]);

  const paymentId =
    subItemId || policies.payments.listItems[0]?.payment.payment_id;
  useEffect(() => {
    if (!caseId || !paymentId) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/policies/${case_type}/${caseId}/payments/${paymentId}/${
          tab || "payment"
        }/view`
      );
    } else if (action === "add") {
      navigate(`/clients/${clientId}/policies/${case_type}/${caseId}/payment/add`);
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/policies/${case_type}/${caseId}/payments/${paymentId}/${
          tab || "payment"
        }/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/policies/${case_type}/${caseId}/payments/${paymentId}/${
          tab || "payment"
        }/view`
      );
    }
  }, [
    action,
    clientId,
    case_type,
    policies.payments.listItems,
    caseId,
    paymentId,
    tab,
    navigate,
  ]);

  useEffect(() => {
    if (subItemId) {
      dispatch(getPolicyPaymentDetailById(subItemId));
    }
  }, [subItemId, dispatch, policies.payments.listItems]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <CaseNavList
        subItem="payments"
        section="policies"
        tab={tab}
        caseType={caseType}
        caseDetail={policies?.payments.activeItem}
        handleDetailPopup={handleDetailPopup}
        notify={showToast}
      />
      <div className="case_container_flex">
        <CaseForm
          mode={action || ""}
          section="policies"
          caseType={caseType}
          caseDetail={policies?.payments.activeItem}
          caseItemList={policies?.payments.listItems}
          tab={tab}
          subItem="payments"
          paymentValue={policies?.payments.totalPayment}
          notify={showToast}
          currentRecord={currentRecord}
          setCurrentRecord={setCurrentRecord}
        />
        <div>
          {policies?.payments.listLoading ? (
            <ContentLoader />
          ) : (
            <>
              {policies?.payments.listItems.length > 0 && (
                <CaseList
                  module="payments"
                  data={policies?.payments.listItems}
                  activeItem={policies?.payments.activeItem}
                  section="policies"
                  activeTab={tab}
                  currentRecord={currentRecord}
                  setCurrentRecord={setCurrentRecord}
                />
              )}
              {!action && policies?.payments.listItems.length === 0 && (
                <NoDataFound />
              )}
            </>
          )}
        </div>
      </div>
      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={policies?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default PolicyPayments;
